import '../styles/home.css'
import React, { useContext, useEffect, useState } from 'react'
// import categories from "../../data/categories";
import heros from "../../data/heros";

import new_arrivals from "../../data/new_arrivals";
import SectionHeader from '../common/section_header';
import HomeSlider from '../layouts/slider';


import { useTranslation } from "react-i18next";
import { LanguageContext } from "../contexts/LanguageContext";
import ProductCard from '../common/product_card';
import axios from 'axios';
import { AppContext } from '../contexts/AppContext';


function Home() {

  const {BASE_URL}=  useContext(AppContext)

const { t } = useTranslation("home");
const { language } = useContext(LanguageContext);
const [isOpen, setIsOpen] = useState(false);
const [categories, setcategories] = useState([]);

// const BASE_URL = "https://portal.banknoteconsult.com/api";

const fetchPopularCategories = () => {
    axios.get(`${BASE_URL}/get_popular_cates`)
    .then(response => {
        if (response.data && response.data.data) {
            setcategories(response.data.data); 
        } else {
            console.error('Invalid response structure');
        }
    })
    .catch(err => {
        console.error('Error fetching popular categories:', err);
    });
    
};



  useEffect(() => {
    fetchPopularCategories()
    
}, []);


return (
<>
    {/* ================================== Slider ================================== */}
    <section>
        <HomeSlider t={t} language={language}/>
    </section>
    <section className='row hero'>
        {heros.map(hero=>(
        <div key={hero.id} className="col-2 mx-3">
            <div className="mx-2 row align-items-center">
                <div className="col-2 mx-2">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/white/hero/${hero.image}`} alt={hero.title} />
                </div>
                <div className="col-9">
                    <p className='title'>{hero.title}</p>
                    <p className='desc'>{hero.desc}</p>
                </div>

            </div>
        </div>
        ))}
    </section>
    <div className="def_padding">

        {/* ================================== Popular Categories ================================== */}
        <section className='popular_categories'>
            <div className="section_title">{t('popular_categories')}</div>
            <div className="row">
                {categories.map((cate) => (
                <div key={cate.id} className="col-2">
                    <div className="cate mx-1">
                        <div className="cate_img"><img
                                src={cate.social_category.image}
                                alt={cate.social_category.name} /></div>
                        <p className='cate_name'>{cate.social_category.name_ar}</p>
                    </div>
                </div>
                ))}
            </div>
        </section>

        {/* ================================== New Arrivals ================================== */}
        <section className='new_arrivals'>
            <SectionHeader t={t} title="popular_categories" path="new_arrivals" />
            <div className="row">
                {new_arrivals.map((new_arrivals) => (
                <div key={new_arrivals.id} className="col-3">
                    <div className="new_arrival mx-1">
                        <div className="new_arrival_img">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/white/new_arrivals/${new_arrivals.name}.svg`}
                                alt={new_arrivals.name} />
                            <div className="fav_container">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/white/empty_love.svg`} alt="" />
                            </div>
                        </div>
                        <p className='new_arrival_name'>{new_arrivals.name}</p>
                    </div>
                </div>
                ))}
            </div>
        </section>

        {/* ==================================  ================================== */}
        <section>
            <div className="row">
                <div className="col-6">
                    <div className="home_card sale_card">
                        {/* <img  src={`${process.env.PUBLIC_URL}/assets/images/white/sale_bg.svg`} alt="sale" /> */}
                    </div>
                </div>
                <div className="col-6">
                    <div className="home_card accessories_card">
                        
                    </div>
                </div>
            </div>
        </section>

        {/* ================================== Food Products ================================== */}
        {/* <section>
            <SectionHeader t={t} title="food_products" path="new_arrivals" />
            <div className="row">
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
            </div>
        </section> */}
        {/* ================================== Top Automotive Deals ================================== */}
        {/* <section>
            <SectionHeader t={t} title="top_automotive_deals" path="new_arrivals" />
            <div className="row">
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                    <ProductCard/>
                   
            </div>
        </section> */}



      

    </div>
</>
)
}

export default Home
